import React, { useEffect, useState } from 'react'

import { Card, Typography, Paper, Grid, Stack, Button, useMediaQuery, FormControl, Select, MenuItem, Tooltip, ClickAwayListener, TextField, InputAdornment, CircularProgress } from '@mui/material';

import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from '../components/SEO';

import { Box } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { getCategories } from '../redux/actions/categoryAction';
import { getEbooks } from '../redux/actions/ebookAction';
import { addDownloads } from '../utils/firebase';
import { getAuth } from 'firebase/auth';
import { ReactComponent as Empty } from "../assets/svg/empty.svg";
import { ReactComponent as Searching } from "../assets/svg/searching_illustration.svg";

import { Search } from '@mui/icons-material';

export default function Ebooks() {
    const matches = useMediaQuery((theme) => theme.breakpoints.up('md'));
    const match = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const [user, setUser] = useState(false)
    const [loading, setLoading] = useState(true);
    const fullScreen = useMediaQuery('(min-width:620px)');

    const category = useSelector((state => state.category))
    const ebook = useSelector((state => state.ebook))

    const [selectedCollection, setSelectedCollection] = useState("None");

    const ebookList = ebook.ebooks

    const handleCollection = (e) => {
        setSelectedCollection(e.target.value)
    }
    const style = {
        background: {
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            }
        },
        iconCenter: {
            width: 100,
            height: 100,
            marginBottom: 5,
            display: "flex",
        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '4%',
                marginRight: '4%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '15%',
                marginRight: '15%',
            },
        },
        cardStyle: {
            opacity: 0.9,
            minHeight: 0,
            width: 95,
            height: 95,
            marginBottom: 5,
            textAlign: "center",
            '@media only screen and (max-width: 900px)': {
                width: 70,
                height: 70
            }
        },
        typography: {
            textAlign: "center",
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 2,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 45,
                textAlign: "left"
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        label: {
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 4,
        },
        divider: {
            marginTop: 4,
            marginBottom: 4
        },
        labelSmall: {
            paddingBottom: 3
        },
        bodyText: {
            fontFamily: "Helvetica Neue",
            paddingBottom: 4,
            marginTop: 1,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 2
            }
        },
        textInstruction: {
            paddingTop: 2
        },
        textPenalty: {
            textAlign: "center",
            paddingBottom: 1
        },
        reserveButton: {
            borderRadius: 5,
            fontWeight: "bold",
            backgroundColor: (theme) => theme.palette.primary.light,
            color: (theme) => theme.palette.common.white,
            border: "3px white solid",
            paddingLeft: 5,
            paddingRight: 5,
            boxShadow: 3,
            "&:hover": {
                backgroundColor: (theme) => theme.palette.primary.main,
            },
        },
        buttonTable: {
            borderRadius: 5,
            fontWeight: "bold",
            backgroundColor: (theme) => theme.palette.secondary.main,
            color: (theme) => theme.palette.common.white,
            border: "3px white solid",
            paddingLeft: fullScreen ? 2 : 1,
            paddingRight: fullScreen ? 2 : 1,
            boxShadow: 3,
            "&:hover": {
                backgroundColor: (theme) => theme.palette.secondary.dark,
            },
        },
        textTable: {
            margin: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    }
    const categoryList = category.categories
    const dispatch = useDispatch();
    useEffect(() => {
        if (getAuth().currentUser) setUser(true)
        if (!category.categoryEmpty && category.categories.length <= 0) {
            dispatch(getCategories());
        }
        if (!ebook.ebookEmpty && ebook.ebooks.length <= 0) {
            dispatch((getEbooks()));
            setLoading(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const ebookClick = (ebookObject) => (e) => {
        e.preventDefault();
        window.open(ebookObject.ebookLink)
        addDownloads(ebookObject.ebookID)
    }

    const [search, setSearch] = useState(false)
    const [payload, setPayload] = useState({
        search: ""
    })
    const firstIndex = 0;
    const [pageSize, setPageSize] = useState(6);
    const [data, setData] = useState(ebookList.slice(firstIndex, pageSize));
    const searchActive = (e) => {
        e.preventDefault();
        setSearch(true);
    }

    const seeMore = (e) => {
        e.preventDefault();
        var tempPage = pageSize + 1;
        setPageSize(tempPage)
    }

    const handleClickAway = () => {
        setSearch(false);
    };

    const handleInputChange = (prop) => (e) => {
        setPayload({ ...payload, [prop]: e.target.value });
        setData(
            ebookList.filter(
                (item) =>
                    item.ebookTitle.toLowerCase().search(
                        e.target.value.toLowerCase()
                    ) !== -1 ||
                    item.ebookAuthor.toLowerCase().search(
                        e.target.value.toLowerCase()
                    ) !== -1
            )
        )
    }

    return (
        <Box>
            <SEO title="E-Books - Baliwag Municipal Library" description="RANIELLA VILLARAMA WEB DEVELOPER PORTFOLIO ... Services offered" />
            <Paper sx={style.background} elevation={0}>
                <Header />
                <Box sx={style.body}>
                    <Typography sx={style.typography} variant="h4" color="default">E-Books</Typography>
                    {search ?
                        <ClickAwayListener onClickAway={handleClickAway}>
                            <TextField
                                autoFocus={search}
                                fullWidth
                                placeholder='Search for Books...'
                                size='small'
                                onChange={handleInputChange("search")}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search sx={{ color: (theme) => theme.palette.borderColor.primary }} />
                                        </InputAdornment>
                                    ),
                                }} />
                        </ClickAwayListener>
                        :
                        <Button
                            startIcon={<Search sx={{ height: 25, width: 25 }} />}
                            variant='outlined'
                            color="primary"
                            fullWidth
                            onClick={searchActive}
                            disableRipple
                            sx={{
                                paddingTop: 0.6,
                                paddingBottom: 0.6,
                                color: (theme) => theme.palette.borderColor.primary,
                                fontSize: 16,
                                borderColor: (theme) => theme.palette.borderColor.primary,
                                justifyContent: "flex-start",
                                textTransform: 'none',
                                "&:hover": {
                                    backgroundColor: "transparent",
                                    borderColor: (theme) => theme.palette.text.primary,
                                },
                            }}
                        > Search for E-Books...
                        </Button>
                    }
                    <Stack direction="row" alignItems="center" sx={{ marginTop: 2, marginBottom: 2 }}>
                        <Box component="span" sx={{ flexGrow: 1 }} />
                        <Typography variant='body1' >Category: </Typography>
                        <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
                            <Select
                                displayEmpty
                                onChange={handleCollection}
                                value={selectedCollection}
                                inputProps={{ 'aria-label': 'Without label' }}
                            >
                                <MenuItem value="None">None</MenuItem>
                                {Array.from(categoryList).map((_, index) => (
                                    <MenuItem value={categoryList[index].id} key={index}>{categoryList[index].categoryTitle}</MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </Stack>
                    <Box sx={{
                        flexGrow: 1,
                        paddingBottom: 4,
                        paddingLeft: matches ? 10 : "2",
                        paddingRight: matches ? 10 : "2",
                    }}>
                        <Card variant="outlined" sx={{ padding: 2, marginTop: 2 }}>
                            <Stack direction="column" spacing={1}>
                                <Grid direction="row" container columns={12} alignItems="center" justifyContent="space-between" spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography variant='body1'
                                            sx={{ margin: 0, fontWeight: "bold", marginLeft: 3 }}>
                                            E-Book Title
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant='body1'
                                            sx={{ margin: 0, fontWeight: "bold" }}>
                                            File Format
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} >
                                        <Box component="span" sx={{ flexGrow: 1 }} />
                                    </Grid>
                                </Grid>
                                {!search ?
                                    ebookList.length > 0 ? Array.from(ebookList).map((_, index) => (
                                        ebookList[index].categoryID === selectedCollection ||
                                            selectedCollection === "None" ?
                                            index < pageSize &&
                                            <Grid container columns={12} alignItems="center" spacing={1} key={index}>
                                                <Grid item xs={4}>
                                                    <Typography variant='body2'
                                                        sx={{ ...style.textTable, marginLeft: 2.6 }}>
                                                        {ebookList[index].ebookTitle}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Typography variant='body2'
                                                        sx={style.textTable}>
                                                        {ebookList[index].ebookAuthor}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4} textAlign="center">
                                                    <Tooltip title={user ? "Download this E-Book and start reading!" : "Please sign in to gain access to this E-Book"}>
                                                        <div>
                                                            <Button
                                                                disabled={!user}
                                                                variant="contained"
                                                                onClick={ebookClick(ebookList[index])}
                                                                sx={style.buttonTable} >
                                                                Download
                                                            </Button>
                                                        </div>
                                                    </Tooltip>

                                                </Grid>
                                            </Grid>
                                            :
                                            <Box />))
                                        : !loading && ebook.ebookEmpty ?
                                            <Grid
                                                container
                                                columns={12}
                                                alignItems="center"
                                                justifyContent="center"
                                                sx={{ marginTop: match ? 3 : 0 }}
                                            >
                                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                    <Empty
                                                        style={{
                                                            height: match ? "68%" : "50%",
                                                            width: match ? "68%" : "50%"
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                    <Typography variant="h5"
                                                        sx={{
                                                            fontWeight: "bold",
                                                            opacity: 0.7,
                                                        }}
                                                    >
                                                        There are no E-Books!
                                                    </Typography>
                                                    <Typography variant="subtitle1"
                                                        sx={{
                                                            fontSize: 15,
                                                            opacity: 0.7,
                                                        }}
                                                    >
                                                        There are no available E-Books as of the moment.
                                                    </Typography>
                                                </Grid>
                                            </Grid> :
                                            <Grid
                                                container
                                                direction="column"
                                                columns={12}
                                                alignItems="center"
                                                justifyContent="center"
                                                sx={{ marginTop: "5%" }}
                                            >
                                                <Grid item xs>
                                                    <CircularProgress />
                                                </Grid>
                                            </Grid>
                                    :
                                    payload.search !== "" ?
                                        data.length > 0 ? Array.from(data).map((_, index) => (
                                            <Grid container columns={12} alignItems="center" spacing={1} key={index}>
                                                <Grid item xs={4}>
                                                    <Typography variant='body2'
                                                        sx={{ ...style.textTable, marginLeft: 2.6 }}>
                                                        {data[index].ebookTitle}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Typography variant='body2'
                                                        sx={style.textTable}>
                                                        {data[index].ebookAuthor}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4} textAlign="center">
                                                    <Tooltip title={user ? "Download this E-Book and start reading!" : "Please sign in to gain access to this E-Book"}>
                                                        <div>
                                                            <Button
                                                                disabled={!user}
                                                                variant="contained"
                                                                onClick={ebookClick(data[index])}
                                                                sx={style.buttonTable} >
                                                                Download
                                                            </Button>
                                                        </div>
                                                    </Tooltip>

                                                </Grid>
                                            </Grid>
                                        )) :
                                            <Grid
                                                container
                                                columns={12}
                                                alignItems="center"
                                                justifyContent="center"
                                                sx={{ marginTop: match ? 3 : 0 }}
                                            >
                                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                    <Searching
                                                        style={{
                                                            height: match ? "68%" : "50%",
                                                            width: match ? "68%" : "50%"
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                    <Typography variant="h5"
                                                        sx={{
                                                            fontWeight: "bold",
                                                            opacity: 0.7,
                                                        }}
                                                    >
                                                        No Results!
                                                    </Typography>
                                                    <Typography variant="subtitle1"
                                                        sx={{
                                                            fontSize: 15,
                                                            opacity: 0.7,
                                                        }}
                                                    >
                                                        Looks like we can't find what you're looking for.
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        :
                                        <Grid
                                            container
                                            columns={12}
                                            alignItems="center"
                                            justifyContent="center"
                                            sx={{ marginTop: match ? 3 : 0 }}
                                        >
                                            <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                <Searching
                                                    style={{
                                                        height: match ? "68%" : "50%",
                                                        width: match ? "68%" : "50%"
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                <Typography variant="h5"
                                                    sx={{
                                                        fontWeight: "bold",
                                                        opacity: 0.7,
                                                    }}
                                                >
                                                    Start Searching!
                                                </Typography>
                                                <Typography variant="subtitle1"
                                                    sx={{
                                                        fontSize: 15,
                                                        opacity: 0.7,
                                                    }}
                                                >
                                                    Start typing to discover more E-Books.
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                }
                            </Stack>
                        </Card>
                        {ebookList.length > pageSize && !search && <Box sx={{ display: "flex", justifyContent: "center" }}>
                            <Button
                                onClick={seeMore}
                                disableRipple
                                fullWidth>
                                See More...
                            </Button>
                        </Box>}
                    </Box>
                </Box>
                <Box sx={{ height: 100 }} />
            </Paper>
            <Box sx={style.footerStyle}>
                <Footer />
            </Box>
        </Box>
    )
}
